/* Nat's Enamel — storefront interactions (vanilla, no deps) */
(function () {
  'use strict';
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var CFG = window.NE_CFG || {};
  var CURRENCY = CFG.currency || 'USD';
  var THRESHOLD = Number(CFG.freeShip || 0); // cents

  function money(cents) {
    try {
      return new Intl.NumberFormat(undefined, { style: 'currency', currency: CURRENCY }).format(cents / 100);
    } catch (e) {
      return (cents / 100).toFixed(2);
    }
  }
  function $(s, c) { return (c || document).querySelector(s); }
  function $all(s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); }

  /* ----------------------------------------------------------- overlays */
  function openDrawer() { document.documentElement.setAttribute('data-cart-open', 'true'); var d = $('.drawer'); var s = $('.scrim'); if (d) d.setAttribute('data-open', 'true'); if (s) s.setAttribute('data-open', 'true'); }
  function closeDrawer() { document.documentElement.removeAttribute('data-cart-open'); var d = $('.drawer'); var s = $('.scrim'); if (d) d.setAttribute('data-open', 'false'); if (s) s.setAttribute('data-open', 'false'); }
  function openMenu() { var m = $('.mnav'); if (m) m.setAttribute('data-open', 'true'); }
  function closeMenu() { var m = $('.mnav'); if (m) m.setAttribute('data-open', 'false'); }

  /* ----------------------------------------------------------- cart */
  function fetchCart() { return fetch(root + 'cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); }); }

  function renderDrawer(cart) {
    var body = $('.drawer__body');
    var foot = $('.drawer__foot');
    if (!body) return;
    // header count
    var hc = $('.drawer__hd .muted');
    if (hc) hc.textContent = cart.item_count ? '(' + cart.item_count + ')' : '';
    // cart badge
    $all('[data-cart-count]').forEach(function (el) {
      if (cart.item_count > 0) { el.textContent = cart.item_count; el.style.display = ''; }
      else { el.style.display = 'none'; }
    });

    if (!cart.items.length) {
      body.innerHTML = '<div class="cart-empty"><div class="display">Your bag is empty</div>' +
        '<p style="margin-bottom:26px">Discover one-of-a-kind enamel creatures.</p>' +
        '<a class="btn" href="' + root + 'collections/all">Shop the atelier</a></div>';
      if (foot) foot.style.display = 'none';
      return;
    }
    if (foot) foot.style.display = '';
    body.innerHTML = cart.items.map(function (l) {
      var opts = (l.options_with_values || []).filter(function (o) { return o.value && o.value.toLowerCase() !== 'default title'; })
        .map(function (o) { return o.value; }).join(' · ');
      var props = '';
      if (l.properties) { for (var k in l.properties) { if (k.charAt(0) !== '_' && l.properties[k]) props += (props ? ' · ' : '') + l.properties[k]; } }
      var sub = [opts, props].filter(Boolean).join(' · ');
      var img = l.image ? '<img class="pimg__art" src="' + l.image + '" alt="" loading="lazy">' : '';
      return '<div class="line" data-key="' + l.key + '">' +
        '<div class="line__img"><div class="pimg">' + img + '</div></div>' +
        '<div class="line__info"><h4>' + l.product_title + '</h4>' +
        '<div class="s">' + (sub || '') + '</div>' +
        '<div class="line__qty"><button data-dec aria-label="Decrease">&#8722;</button><span>' + l.quantity + '</span><button data-inc aria-label="Increase">+</button></div>' +
        '<div class="p">' + money(l.final_line_price) + '</div>' +
        '<button class="line__rm" data-rm>Remove</button></div></div>';
    }).join('');

    // free-ship progress + subtotal
    var remaining = Math.max(0, THRESHOLD - cart.total_price);
    var pct = THRESHOLD > 0 ? Math.min(100, (cart.total_price / THRESHOLD) * 100) : 100;
    var note = THRESHOLD <= 0 ? '' :
      (remaining > 0
        ? '<div class="cart-note">Add <b>' + money(remaining) + '</b> more for complimentary shipping</div>'
        : '<div class="cart-note">&#10003; You’ve unlocked complimentary worldwide shipping</div>');
    if (foot) {
      foot.innerHTML = note +
        (THRESHOLD > 0 ? '<div class="ship-bar"><i style="width:' + pct + '%"></i></div>' : '') +
        '<div class="cart-sub" style="margin-top:16px"><span class="label" style="color:var(--ink)">Subtotal</span><b>' + money(cart.total_price) + '</b></div>' +
        '<div class="cart-note">Taxes &amp; shipping calculated at checkout</div>' +
        '<a class="btn btn--accent btn--block btn--lg" style="margin-top:8px" href="' + root + 'checkout">Checkout</a>' +
        '<button class="btn btn--ghost btn--block" style="margin-top:10px;min-height:48px" data-cart-close>Continue shopping</button>';
    }
  }

  function refreshCart(open) {
    return fetchCart().then(function (cart) { renderDrawer(cart); if (open) openDrawer(); return cart; });
  }

  function addToCart(payload, open) {
    return fetch(root + 'cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(payload)
    }).then(function (r) { return r.json(); }).then(function () { return refreshCart(open !== false); });
  }

  function changeLine(key, qty) {
    return fetch(root + 'cart/change.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function (r) { return r.json(); }).then(function (cart) { renderDrawer(cart); return cart; });
  }

  /* ----------------------------------------------------------- delegation */
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-cart-open],[data-cart-close],[data-menu-open],[data-menu-close],[data-add],[data-rm],[data-inc],[data-dec]');
    if (!t) {
      if (e.target.classList && e.target.classList.contains('scrim')) closeDrawer();
      return;
    }
    if (t.hasAttribute('data-cart-open')) { e.preventDefault(); refreshCart(true); }
    else if (t.hasAttribute('data-cart-close')) { e.preventDefault(); closeDrawer(); }
    else if (t.hasAttribute('data-menu-open')) { e.preventDefault(); openMenu(); }
    else if (t.hasAttribute('data-menu-close')) { e.preventDefault(); closeMenu(); }
    else if (t.hasAttribute('data-add')) {
      e.preventDefault(); e.stopPropagation();
      var id = t.getAttribute('data-add'); if (!id) return;
      t.setAttribute('disabled', 'true');
      addToCart({ items: [{ id: Number(id), quantity: 1 }] }).then(function () { t.removeAttribute('disabled'); });
    }
    else if (t.hasAttribute('data-rm') || t.hasAttribute('data-inc') || t.hasAttribute('data-dec')) {
      var line = t.closest('.line'); if (!line) return;
      var key = line.getAttribute('data-key');
      var qtyEl = $('.line__qty span', line);
      var cur = qtyEl ? Number(qtyEl.textContent) : 1;
      var next = t.hasAttribute('data-rm') ? 0 : t.hasAttribute('data-inc') ? cur + 1 : cur - 1;
      changeLine(key, next);
    }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') { closeDrawer(); closeMenu(); } });

  /* ----------------------------------------------------------- accordions */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('.acc__btn'); if (!b) return;
    var item = b.closest('.acc__item');
    item.setAttribute('data-open', item.getAttribute('data-open') === 'true' ? 'false' : 'true');
  });

  /* ----------------------------------------------------------- PDP variant + qty */
  function initProductForm(form) {
    var data = form.querySelector('[data-variants]');
    var variants = data ? JSON.parse(data.textContent) : [];
    var idInput = form.querySelector('[name="id"]');
    var priceNow = form.querySelector('[data-price-now]');
    var priceWas = form.querySelector('[data-price-was]');
    var addLabel = form.querySelector('[data-add-label]');
    var addBtn = form.querySelector('[data-add-submit]');
    var qtyEl = form.querySelector('[data-qty]');
    var qtyInput = form.querySelector('[name="quantity"]');
    var chips = $all('.chip-sq', form);

    function current() {
      if (!variants.length) return null;
      var sel = form.querySelector('.chip-sq[aria-pressed="true"]');
      var vid = sel ? sel.getAttribute('data-variant') : (idInput ? idInput.value : null);
      return variants.filter(function (v) { return String(v.id) === String(vid); })[0] || variants[0];
    }
    function qty() { return qtyInput ? Number(qtyInput.value) : 1; }
    function update() {
      var v = current();
      if (!v) return;
      if (idInput) idInput.value = v.id;
      if (priceNow) priceNow.textContent = money(v.price);
      if (priceWas) priceWas.style.display = (v.compare_at_price && v.compare_at_price > v.price) ? '' : 'none';
      if (priceWas && v.compare_at_price) priceWas.textContent = money(v.compare_at_price);
      if (addLabel) addLabel.textContent = v.available ? ('Add to bag — ' + money(v.price * qty())) : 'Sold out';
      if (addBtn) { if (v.available) addBtn.removeAttribute('disabled'); else addBtn.setAttribute('disabled', 'true'); }
    }
    chips.forEach(function (c) {
      c.addEventListener('click', function () {
        chips.forEach(function (x) { x.setAttribute('aria-pressed', 'false'); });
        c.setAttribute('aria-pressed', 'true');
        update();
      });
    });
    $all('[data-qty-dec],[data-qty-inc]', form).forEach(function (btn) {
      btn.addEventListener('click', function () {
        var n = qty(); n = btn.hasAttribute('data-qty-inc') ? n + 1 : Math.max(1, n - 1);
        if (qtyInput) qtyInput.value = n; if (qtyEl) qtyEl.textContent = n; update();
      });
    });
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var v = current(); if (v && v.available === false) return;
      var fd = new FormData(form);
      var payload = { items: [{ id: Number(fd.get('id')), quantity: Number(fd.get('quantity') || 1) }] };
      // line item properties (chain when not a real variant)
      var props = {};
      $all('[name^="properties["]', form).forEach(function (i) {
        var m = i.name.match(/properties\[(.+)\]/); if (m && i.value) props[m[1]] = i.value;
      });
      var sel = form.querySelector('.chip-sq[aria-pressed="true"]');
      if (sel && sel.hasAttribute('data-prop')) props[sel.getAttribute('data-prop-name') || 'Chain'] = sel.getAttribute('data-prop');
      if (Object.keys(props).length) payload.items[0].properties = props;
      addToCart(payload);
    });
    update();
  }
  $all('[data-product-form]').forEach(initProductForm);

  // initialise badge on load
  refreshCart(false);
})();
